import styled from 'styled-components';
import { Button } from '../Button';

export const FormButton = styled(Button)`

`;